import moment from 'moment';

export const getDateTime = date => {
    return moment(date).format('MMM DD, YYYY @ LT');
}